import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  try {
    return await GET(
      `/admin/roles?page=${currentPage || 1}&per_page=${
        perPage || 10
      }&name=${search || ""}`,
    );
  } catch (error) {
    console.error("Error fetching Master list:", error);
    throw error;
  }
};

export const findOne = async (id) => {
  try {
    return await GET(`/admin/roles/${id}`);
  } catch (error) {
    console.error(`Error fetching Master with id ${id}:`, error);
    throw error;
  }
};

export const Create = async (data) => {
  try {
    return await POST(`/admin/roles`, data);
  } catch (error) {
    console.error("Error creating Master:", error);
    throw error;
  }
};

export const Update = async (id, data) => {
  try {
    return await PUT(`/admin/roles/${id}`, data);
  } catch (error) {
    console.error(`Error updating Master ${id}:`, error);
    throw error;
  }
};

export const Status = async (id) => {
  try {
    return await POST(`/admin/roles/${id}`);
  } catch (error) {
    console.error(`Error updating status for Master ${id}:`, error);
    throw error;
  }
};

export const Delete = async (id) => {
  try {
    return await DELETE(`/admin/roles/${id}`);
  } catch (error) {
    console.error(`Error deleting Master ${id}:`, error);
    throw error;
  }
};
